const CONFIG = {
  actionSectionClassName: 'external-contactUs-ActionSection',
  partnersApiUrlAttribute: 'data-is-visible-api-url',
  hideElementClassName: 'is-hidden'
}

export function validateUrlStatus (apiUrl, section, onComplete) {
  let xhr = new XMLHttpRequest()
  xhr.open('GET', apiUrl, true)
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) {
      if (xhr.status === 200) {
        section.classList.remove(CONFIG.hideElementClassName)
        if (typeof onComplete === 'function') {
          onComplete(true)
        }
      } else if (typeof onComplete === 'function') {
        onComplete(false)
      }
    }
  }
  xhr.send(null)
}

export function setVisibilityOfPartnersSection () {
  const actionSections = document.getElementsByClassName(CONFIG.actionSectionClassName)
  if (!actionSections.length) {
    return void (0)
  }
  let apiUrl
  for (let section of actionSections) {
    apiUrl = section.getAttribute(CONFIG.partnersApiUrlAttribute)
    if (apiUrl) {
      validateUrlStatus(apiUrl, section)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/action-section/action-section.js